/* Press-and-hold to flip product cards on touch screens (Canvas Art etc.). Flips while the finger is down; swipes and quick taps behave normally. */
(function(){
  if(window.__nsFlip)return;window.__nsFlip=1;
  var timer,card,sx,sy,swallow=0;
  function off(){clearTimeout(timer);if(card){card.classList.remove('is-flipped');card=null}}
  document.addEventListener('touchstart',function(e){
    var f=e.target.closest&&e.target.closest('.flipcard .flip');
    off();if(!f||e.touches.length>1)return;
    var t=e.touches[0];sx=t.clientX;sy=t.clientY;var c=f.closest('.flipcard');
    timer=setTimeout(function(){card=c;c.classList.add('is-flipped');swallow=Date.now()+1500},350);
  },{passive:true});
  document.addEventListener('touchmove',function(e){
    var t=e.touches[0];if(Math.abs(t.clientX-sx)>8||Math.abs(t.clientY-sy)>8){clearTimeout(timer);if(card){card.classList.remove('is-flipped');card=null;swallow=0}}
  },{passive:true});
  document.addEventListener('touchend',function(){var held=!!card;off();if(held)swallow=Date.now()+400},{passive:true});
  document.addEventListener('touchcancel',function(){off();swallow=0},{passive:true});
  document.addEventListener('click',function(e){if(swallow&&Date.now()<swallow&&e.target.closest&&e.target.closest('.flipcard .flip')){e.preventDefault();e.stopPropagation()}swallow=0},true);
  document.addEventListener('contextmenu',function(e){if(e.target.closest&&e.target.closest('.flipcard .flip')&&window.matchMedia('(hover: none)').matches)e.preventDefault()});
})();